import type { ReactNode, FC } from 'react';
import c from 'classnames';

import s from './ReportsTableRowMobile.scss';

interface Props {
  extras?: ReactNode;
  children: ReactNode;
  compact?: boolean;
}

const ReportsTableRowMobile: FC<Props> = ({ children, extras, compact }) => {
  return (
    <div className={c(s['root'], compact && s['compact'])}>
      {children}
      {extras && <div className={s['extras']}>{extras}</div>}
    </div>
  );
};
ReportsTableRowMobile.displayName = 'ReportsTableRowMobile';

export default ReportsTableRowMobile;
